import API from 'api/clients'
import { all, fork } from 'redux-saga/effects'

import OrchestrationSaga from './OrchestrationSaga'

export default function* orchestrationSagas() {
  yield all([fork(new OrchestrationSaga(API).supervise)])
}
